// eslint no-unused-vars: 0

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { TabContent, Col, Row } from 'reactstrap';
import TabulatorNav from '../../TabulatorNav';
import { formUtilsHocPropTypes } from '../../../propTypes';
import { Field } from 'react-final-form';
// import * as RichText from '../../../utils/richText/index.js';
// import prettier from 'prettier/standalone';
// import parserHtml from 'prettier/parser-html';
// import Editor from '../../LexicalEditor';
// import FormFieldCodeMirror from '../FormFieldCodeMirror';
// import Monaco from '@monaco-editor/react';
// import { prettyHtml } from '../../../utils';
// import { TranslationFieldValue } from './TranslationFieldValue';
// import { faCode, faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import FormFieldTranslationEditor from './FormFieldTranslationEditor';
import TranslationFieldPreview, { useTranslationFieldPreview } from './TranslationFieldPreview';

const propTypes = {
    form: PropTypes.object.isRequired,
    utils: formUtilsHocPropTypes.isRequired,
    propertyName: PropTypes.string.isRequired,
    header: PropTypes.string,
    className: PropTypes.string,
    tinyMCEButtonGenerator: PropTypes.func,
    tinyMCEVariables: PropTypes.object,
    tinyMCEProfile: PropTypes.object,
    customSettings: PropTypes.object,
    charControlHandler: PropTypes.func
};

/**
 * @typedef FormFieldTranslationsQuillProperties
 * @property {any} form
 * @property {any} utils
 * @property {any} propertyName
 * @property {any} header
 * @property {any} className
 * @property {() => import('../../LexicalEditor/plugins/ToolbarPlugin/Toolbar').IToolbarActionDefinition[]} tinyMCEButtonGenerator
 * @property {string[]} tinyMCEVariables
 * @property {any} tinyMCEProfile
 * @property {any} [resetValue]
 * @property {any} customSettings
 * @property {any} [customStyles]
 * @property {any} charControlHandler
 */

/**
 * @param {FormFieldTranslationsQuillProperties} properties
 */
const FormFieldTranslationsQuill = ({
    form,
    utils,
    propertyName,
    header,
    className,
    tinyMCEButtonGenerator,
    tinyMCEVariables,
    tinyMCEProfile,
    resetValue,
    customSettings,
    customStyles,
    charControlHandler
}) =>
{
    const initialValuesFromForm = form.getState().initialValues;
    const translationsInputs = Object.keys(initialValuesFromForm).reduce((acc, curr) => curr.includes(`${propertyName}-`) ? { ...acc, [curr]: initialValuesFromForm[curr] } : acc, {});
    const [activeLanguageTab, setActiveLanguageTab] = useState(utils.currentLanguage());
    const previewState = useTranslationFieldPreview();
    const activeTabKey = propertyName + '-' + (activeLanguageTab[0].toUpperCase() + activeLanguageTab[1].toLowerCase()) + '-translations';
    React.useEffect(() =>
    {
        const htmlValue = form.getFieldState(activeTabKey)?.value || '';
        previewState.setHtml(htmlValue, false);
    },
    [activeLanguageTab, form]);
    React.useEffect(() => { previewState.setCss(customStyles); }, [customStyles]);
    /** @type {(value: string|undefined) => void} */
    const handlePreviewClick = value =>
    {
        previewState.open(value);
    };
    return <>
        <div className={clsx('w-100', className)}>
            {/* <FormGroup check className="mb-1">
                <Input
                    type="checkbox"
                    value={isSourceCodeMode}
                    onChange={e => setIsSourceCodeMode(e.target.checked)}
                />
                {' '}
                <Label check>Source code</Label>
            </FormGroup> */}

            <p className="text-muted mb-1">{header}</p>

            <TabulatorNav
                setActiveTab={setActiveLanguageTab}
                activeTab={activeLanguageTab}
                tabsList={utils.allLanguagesDetails().map(language => ({ iso: language.iso.toLowerCase(), label: language.nativeName }))}
            />

            <TabContent>
                <Row>
                    <Col className="col-12">
                        {
                            Object.keys(translationsInputs)
                            .map(key =>
                            {
                                const isActive = key === activeTabKey;
                                return (
                                    <div
                                        className='w-100'
                                        key={key}
                                        style={{ display: (isActive ? 'block' : 'none') }}
                                    >
                                        {
                                            // !isSourceCodeMode ?
                                            //     <Field name={key}>
                                            //         {
                                            //             props =>
                                            //                 <Editor
                                            //                     key={`${props.input.name}`}
                                            //                     {...props.input}
                                            //                     generateCustomButtons={tinyMCEButtonGenerator}
                                            //                     variables={tinyMCEVariables}
                                            //                     customSettings={customSettings}
                                            //                     customStyles={customStyles}
                                            //                     charControlHandler={charControlHandler}
                                            //                 />
                                            //         }
                                            //     </Field> :
                                            //     <FormFieldCodeMirror
                                            //         form={form}
                                            //         utils={utils}
                                            //         name={key}
                                            //         options={{
                                            //             mode: 'htmlmixed',
                                            //             theme: 'material',
                                            //             lineNumbers: true
                                            //         }}
                                            //     />

                                            // <FormFieldCodeMirror
                                            //     form={form}
                                            //     utils={utils}
                                            //     name={key}
                                            //     options={{
                                            //         mode: 'htmlmixed',
                                            //         theme: 'eclipse',
                                            //         lineNumbers: true
                                            //     }}
                                            // />

                                            <Field name={key}>
                                                {
                                                    props => <FormFieldTranslationEditor
                                                        properties={props}
                                                        additionalButtons={tinyMCEButtonGenerator}
                                                        editorVariables={tinyMCEVariables}
                                                        editorProfile={tinyMCEProfile}
                                                        customSettings={customSettings}
                                                        customStyles={customStyles}
                                                        charControlHandler={charControlHandler}
                                                        resetValue={resetValue}
                                                        onChange={previewState.setHtml}
                                                        onPreviewClick={handlePreviewClick} />
                                                }
                                            </Field>
                                        }
                                    </div>
                                );
                            })
                        }
                    </Col>
                </Row>
            </TabContent>
        </div>
        <TranslationFieldPreview state={previewState} />
    </>;
};

FormFieldTranslationsQuill.propTypes = propTypes;

export default FormFieldTranslationsQuill;
